export var VelavuSubscriptionStatus;
(function (VelavuSubscriptionStatus) {
    VelavuSubscriptionStatus["Active"] = "active";
    VelavuSubscriptionStatus["Trialing"] = "trialing";
    VelavuSubscriptionStatus["Paused"] = "paused";
})(VelavuSubscriptionStatus || (VelavuSubscriptionStatus = {}));
//# sourceMappingURL=subscription.js.map